import React from 'react';
import { Link } from 'react-router-dom';
import SectionAd from '../components/ads/SectionAd';

const internalLinks = [
  {
    to: '/auth',
    label: 'Crea Account / Accedi',
    description: 'Entra subito nel gioco, crea il tuo profilo e inizia a gestire la tua fazione.',
    icon: 'bi-person-plus-fill',
    highlight: true
  },
  {
    to: '/rules',
    label: 'Regolamento',
    description: 'Leggi le regole base per capire subito come si gioca.',
    icon: 'bi-journal-text'
  },
  {
    to: '/premium',
    label: 'Fantawrestling Premium',
    description: 'Scopri i contributi premium e le future funzioni sbloccabili per chi sostiene il progetto.',
    icon: 'bi-stars'
  }
];

const externalLinks = [
  {
    href: 'https://t.me/fantawrestlingchat',
    label: 'Gruppo Telegram',
    description: 'Entra nella chat della community e chatta con noi.',
    icon: 'bi-telegram',
    accent: 'telegram'
  },
  {
    href: 'https://www.instagram.com/fanta.wrestling',
    label: 'Instagram',
    icon: 'bi-instagram',
    accent: 'instagram'
  },
  /*
  {
    href: 'https://www.tiktok.com/@fanta.wrestling',
    label: 'TikTok',
    icon: 'bi-tiktok',
    accent: 'tiktok'
  },
  */
  {
    href: 'https://www.youtube.com/@FantaWrestlingIT',
    label: 'YouTube',
    icon: 'bi-youtube',
    accent: 'youtube'
  }
];

function AllLinks() {
  return (
    <div className="all-links-page">
      <div className="container py-1">

        <section className="all-links-section">
          <div className="all-links-section__head">
            <span className="all-links-section__eyebrow">Naviga nel sito</span>
          </div>

          <div className="all-links-grid">
            {internalLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`all-links-card ${item.highlight ? 'all-links-card--highlight' : ''}`}
              >
                <div className="all-links-card__icon">
                  <i className={`bi ${item.icon}`}></i>
                </div>
                <div className="all-links-card__content">
                  <h3>{item.label}</h3>
                  <p>{item.description}</p>
                </div>
                <i className="bi bi-arrow-up-right-circle-fill all-links-card__arrow"></i>
              </Link>
            ))}
          </div>
        </section>

        <section className="all-links-section">
          <div className="all-links-section__head">
            <span className="all-links-section__eyebrow">Seguici e rimani connesso</span>
          </div>

          <div className="all-links-grid">
            {externalLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                target="_blank"
                rel="noreferrer"
                className={`all-links-card all-links-card--${item.accent}`}
              >
                <div className="all-links-card__icon">
                  <i className={`bi ${item.icon}`}></i>
                </div>
                <div className="all-links-card__content">
                  <h3>{item.label}</h3>
                  <p>{item.description}</p>
                </div>
                <i className="bi bi-box-arrow-up-right all-links-card__arrow"></i>
              </a>
            ))}
          </div>
        </section>
        <SectionAd placement="homeBottom" className="d-flex justify-content-center my-2" />
      </div>
    </div>
  );
}

export default AllLinks;
